import React, { useEffect, useRef } from 'react';
import { useClipShare } from '../hooks/useClipShare';
import { ChatHeader } from './ChatHeader';
import { ChatMessages } from './ChatMessages';
import { ClipboardMonitor } from './ClipboardMonitor';
import { ChatInput } from './ChatInput';

export const ChatRoom: React.FC = () => {
  const { sessionCode, userNickname, connectionStatus } = useClipShare();
  const chatRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Auto-scroll to bottom when new messages arrive
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, []);

  return (
    <div className="chat-room">
      <ChatHeader 
        sessionCode={sessionCode || ''}
        userNickname={userNickname}
        connectionStatus={connectionStatus}
      />
      
      <div ref={chatRef} className="chat-messages-container">
        <ChatMessages />
      </div>
      
      <ClipboardMonitor />
      <ChatInput />
    </div>
  );
};